import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import BlogPreview from './components/BlogPreview';
import TrustSection from './components/TrustSection';
import SchemaOrg from '../../components/feature/SchemaOrg';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

const homeSchema = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'WebSite',
      '@id': `${siteUrl}/#website`,
      url: siteUrl,
      name: 'Simsers Affiliate',
      description: 'Honest, research-backed product reviews across 23 niches — health supplements, betting strategies, digital marketing, eco living, and more.',
      publisher: { '@id': `${siteUrl}/#organization` },
      potentialAction: {
        '@type': 'SearchAction',
        target: { '@type': 'EntryPoint', urlTemplate: `${siteUrl}/?s={search_term_string}` },
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@type': 'Organization',
      '@id': `${siteUrl}/#organization`,
      name: 'Simsers Affiliate',
      url: siteUrl,
      logo: {
        '@type': 'ImageObject',
        url: 'https://public.readdy.ai/ai/img_res/eb40fa79-3681-4e55-a899-5bfa4896fbbe.png',
      },
      sameAs: [],
    },
    {
      '@type': 'WebPage',
      '@id': `${siteUrl}/#webpage`,
      url: siteUrl,
      name: 'Simsers Affiliate – Honest Reviews & Expert Recommendations Across 23 Niches',
      description: 'Simsers Affiliate delivers research-backed, honest product reviews across 23 niches — health supplements, betting strategies, digital marketing, eco living, and more.',
      isPartOf: { '@id': `${siteUrl}/#website` },
      about: { '@id': `${siteUrl}/#organization` },
      datePublished: '2025-01-01',
      dateModified: '2026-02-08',
      breadcrumb: {
        '@type': 'BreadcrumbList',
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: 'Home', item: siteUrl },
        ],
      },
    },
  ],
};

const HomePage = () => {
  useEffect(() => {
    document.title = 'Simsers Affiliate – Honest Reviews & Expert Recommendations Across 23 Niches';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) metaDesc.setAttribute('content', 'Simsers Affiliate delivers research-backed, honest product reviews across 23 niches — health supplements, betting strategies, digital marketing, eco living, and more. Make smarter buying decisions today.');
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) canonical.setAttribute('href', `${siteUrl}/`);
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      <SchemaOrg schema={homeSchema} id="schema-home" />
      <Header />
      <main>
        <h1 className="sr-only">Simsers Affiliate - Expert Insights & Trusted Recommendations</h1>
        <HeroSection />
        <CategoryGrid />
        <BlogPreview />
        <TrustSection />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
